import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  position: relative;
`

export const Footer = styled.footer`
  width: 100%;
  padding: 10px;

  display: flex;
  justify-content: flex-end;
`
